module.exports = __webpack_public_path__ + "static/media/MT103.bc95f686.svg";